import React, { useMemo } from "react";
import { TabContainerProps } from "@companion-core/shared/app/Components/TabContainer/TabContainer.model";
import { TextInShape } from "@companion-core/shared/app/Components/TextInShape";
import { DynamicContent } from "@companion-core/shared/app/Components/Blocks/DynamicContent";
import { useTabContainer } from "@companion-core/shared/app/Components/TabContainer/hooks/tabContainer";
import "@companion-core/web/src/Assets/Styles/scss/tabContainer.scss";

export const TabContainer = ({ name, tabBlocks }: TabContainerProps) => {
  const { activeTab, setActiveTab, lang, orderedTabs } = useTabContainer();
  const multipleTabs = useMemo(() => orderedTabs.length > 1, [orderedTabs]);

  return (
    <div
      data-testid={`tab-container--${name}`}
      className={`tab-container ${!multipleTabs ? "tab-container--one-tab-only" : ""}`}>
      {multipleTabs && (
        /* Show tab list selector only when we have at least two tab blocks */
        <div data-testid={`tab-container__tab-list--${name}`} className="tab-container__tab-list">
          {orderedTabs.map((tabContent) => (
            <TextInShape
              key={tabContent.slug}
              testID={"tab-container__tab-list-item"}
              value={tabContent.slug}
              text={tabContent.title}
              selected={tabContent.slug === activeTab}
              onClick={() => setActiveTab(tabContent.slug)}
            />
          ))}
        </div>
      )}
      <div
        data-testid={`tab-container__tab-content-${name}`}
        className="tab-container__tab-content">
        {tabBlocks.map((tabBlock) => (
          <div
            key={`block-tab-${tabBlock.slug}`}
            data-testid={`tab-container__tab-content--${tabBlock.slug}`}
            className={
              activeTab === tabBlock.slug
                ? "tab-container__tab--active"
                : "tab-container__tab--inactive"
            }>
            <DynamicContent
              type="tab"
              contentProps={{
                id: tabBlock.id,
                slug: tabBlock.slug,
                lang: lang,
                displayType: tabBlock.display_type,
                isInContainer: true,
                order: tabBlock.order,
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
